import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  Paper,
  Alert,
  Divider
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ExecutionsQuickActions from './ExecutionsQuickActions';
import ExecutionsTimelineSimple from './ExecutionsTimelineSimple';

const ExecutionsDemo = () => {
  const navigate = useNavigate();
  const [demoTradeId] = useState('demo-trade-123');

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        DWLF Trade Journal v2 - Executions System Demo
      </Typography>
      
      <Alert severity="info" sx={{ mb: 3 }}>
        This is a demo of the new executions-first trading system. The system supports partial exits, 
        scale-ins, and complex position management through individual executions.
      </Alert>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Key Features
              </Typography>
              <Box component="ul" sx={{ pl: 2 }}>
                <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                  <strong>Partial Exits:</strong> Exit portions of your position at different prices
                </Typography>
                <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                  <strong>Scale-ins:</strong> Add to positions at better prices
                </Typography>
                <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                  <strong>Real-time P&L:</strong> See realized and unrealized P&L instantly
                </Typography>
                <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                  <strong>Adjustment Tracking:</strong> Move stops and take profits with full history
                </Typography>
                <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                  <strong>Complete Audit Trail:</strong> Every position change is recorded
                </Typography>
              </Box>
              
              <Divider sx={{ my: 2 }} />
              
              <Typography variant="body2" color="text.secondary">
                Try the Quick Actions below to add executions and adjustments to this demo trade.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, md: 8 }}>
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Quick Actions Demo
              </Typography>
              <ExecutionsQuickActions 
                tradeId={demoTradeId}
                currentPrice={150.25}
              />
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Timeline Demo
              </Typography>
              <ExecutionsTimelineSimple tradeId={demoTradeId} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box sx={{ mt: 3, textAlign: 'center' }}>
        <Button 
          variant="contained" 
          onClick={() => navigate('/trades')}
          sx={{ mr: 2 }}
        >
          View All Trades
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => navigate('/')}
        >
          Back to Dashboard
        </Button>
      </Box>
    </Box>
  );
};

export default ExecutionsDemo;
